/**
 * Colored status badge pill.
 * Maps job status values to Tailwind colors from the theme.
 */

const STATUS_STYLES = {
  pending_bom:        'bg-gray-100 text-gray-500',
  bom_review:         'bg-status-bom-review/15 text-status-bom-review',
  waiting_on_quotes:  'bg-status-waiting-quotes/15 text-status-waiting-quotes',
  quotes_received:    'bg-status-quotes-received/15 text-status-quotes-received',
  waiting_on_parts:   'bg-status-waiting-parts/15 text-status-waiting-parts',
  ready_to_build:     'bg-status-ready-to-build/15 text-status-ready-to-build',
  building:           'bg-status-building/15 text-status-building',
  testing:            'bg-status-testing/15 text-status-testing',
  installation:       'bg-status-installation/15 text-status-installation',
  ready_to_ship:      'bg-status-ready-to-ship/15 text-status-ready-to-ship',
  shipped:            'bg-status-shipped/15 text-status-shipped',
  archived:           'bg-status-archived/15 text-status-archived',
  cancelled:          'bg-red-100 text-red-600',
  in_design:          'bg-purple-100 text-purple-700',
};

const STATUS_LABELS = {
  pending_bom:       'Pending BOM',
  bom_review:        'BOM Review',
  waiting_on_quotes: 'Waiting on Quotes',
  quotes_received:   'Quotes Received',
  waiting_on_parts:  'Waiting on Parts',
  ready_to_build:    'Ready to Build',
  building:          'Building',
  testing:           'Testing',
  installation:      'Installation',
  ready_to_ship:     'Ready to Ship',
  shipped:           'Shipped',
  archived:          'Archived',
  cancelled:         'Cancelled',
  in_design:         'In Design',
};

export default function StatusBadge({ status, label: labelOverride, className = '' }) {
  const styles = STATUS_STYLES[status] || 'bg-gray-100 text-gray-600';
  const label = labelOverride || STATUS_LABELS[status] || status;

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${styles} ${className}`}
    >
      {label}
    </span>
  );
}
